import { getShiftPositionDetailsFunctionDef, } from '../../../../backend/features/shift/shared';
import { defaultFetcherOptions } from '../../../../ui/utils/defaultFetcherOptions';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import useSWR from 'swr';
export const getShiftPositionDetailsKey = 'getShiftPositionDetails';
export const useShiftPositionDetails = (params) => {
    const getShiftPositionDetailsPlatformFn = useTypedPlatformFunction(getShiftPositionDetailsFunctionDef);
    const getShiftPositionDetails = (params) => {
        return getShiftPositionDetailsPlatformFn(params).catch(handleErrorSnackbar);
    };
    const { data: shiftPositionDetails, isLoading } = useSWR([getShiftPositionDetailsKey, params], params.loadData
        ? ([, params]) => {
            return getShiftPositionDetails({
                shiftId: params.shiftId,
                positionId: params.positionId,
            }).then((response) => {
                return response;
            });
        }
        : null, defaultFetcherOptions);
    return {
        shiftPositionDetails,
        isLoading,
    };
};
